module.exports = __webpack_public_path__ + "d075e0fe12d641119b347496309feaa6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-11.png
// module id = 1591
// module chunks = 0